export default __webpack_public_path__ + "e0bf0a2.png";